/** FAQ accordion answer renderer (shared by marketing FAQ + article FAQ blocks). */
export function renderFaqAnswerBody(t, faq) {
  const raw = t(faq.aKey, faq.params)
  if (faq.multiParagraph) {
    return raw
      .split(/\n\n+/)
      .map((p) => p.trim())
      .filter(Boolean)
      .map((para, j) => (
        <p key={j} className="faq-accordion__answer-p">
          {para}
        </p>
      ))
  }
  return <p>{raw}</p>
}
